/* ================================================== */
/* FUNCTIONS
/* ================================================== */

function fixedNav(){
  if(!$('body').hasClass('mobile')){
    if ($(window).scrollTop() >= $('#header').outerHeight()) {
      $('header').addClass('fixed');
      $('body').addClass('header-fixed');
    } else {
      $('header').removeClass('fixed');
      $('body').removeClass('header-fixed');
    }
  }
}

/* ================================================== */
/* DOCUMENT READY
/* ================================================== */

$(document).ready(function(){

  /* ================================================== */
  /* DROPDOWN
  /* ================================================== */

  var dropdownOpen = false;

  // Open / close on click
  $('.dropdown').each(function(index, element){
    $('.dropdown-toggle', element).click(function(){
      if (!breakpoint_xs){
        if ($('.dropdown--open').length && !$(this).parents('.dropdown:first').hasClass('dropdown--open') && dropdownOpen == true){
          $('.dropdown--open .dropdown-menu').slideFadeToggle(300);
          $('.dropdown--open').removeClass('dropdown--open');
          dropdownOpen = false;
        }

        $('.dropdown-menu', element).slideFadeToggle(300);
        $(this).parents('.dropdown:first').toggleClass('dropdown--open');
        
      }

      if ($(this).parents('.dropdown:first').hasClass('dropdown--open')) {
        dropdownOpen = true;
      } else {
        dropdownOpen = false;
      }
    });

    $('.dropdown-menu li', element).click(function(event){
      if (!breakpoint_xs || $(this).parents('.dropdown-toggle:first').hasClass('btn--filter')){
        event.stopPropagation();
        $('.dropdown-menu', element).slideFadeToggle(300).find('.is-checked').removeClass('is-checked');
        $(this).addClass('is-checked');
        $('.dropdown-toggle span', element).html($('a', this).html());
      }
    });
  });

  // Close dropdown on clic outside
  $(document).click(function(event) { 
    if(!$(event.target).closest('.dropdown').length && !$(event.target).is('.dropdown')) {
      if (dropdownOpen == true) {
        $('.dropdown--open .dropdown-menu').slideFadeToggle(300);
        $('.dropdown--open').removeClass('dropdown--open');
        dropdownOpen = false;
      }
    }
  });


  /* ================================================== */
  /* DROPDOWN > Header menu
  /* ================================================== */

  // Close header dropdowns before page change
  $('#layout--header .dropdown-menu a:not(.dropdown-toggle)').each(function(index, element){
    $(element).click(function(event){
      if (!breakpoint_xs || $(this).parents('.dropdown-toggle:first').hasClass('btn--filter')){
        event.preventDefault();

        // Close current opened menu
        $(element).parents('.dropdown--open:first').removeClass('dropdown--open');

        // Redirect after transition if page change
        if (window.location.href !== $(element).attr('href')){
          setTimeout(function(){
            window.location.href = $(element).attr('href');
          }, 500);
        }
      }
    });
  });


  /* ================================================== */
  /* MENU ACTIVE
  /* ================================================== */  
  
  var menuItem = $('.nav--menu .nav__li');
  
  $(menuItem).each(function(){
    if(window.location.href.indexOf($(this).find('a:first').attr('href'))>-1) {
      $(this).addClass('active').siblings().removeClass('active');
    }
  });

  /* ================================================== */
  /* SMOOTH SCROLL
  /* ================================================== */  
  
  $('a[href^="#"]').click(function(){
    var the_id = $(this).attr("href");
  
    $('html, body').animate({
      scrollTop:$(the_id).offset().top
    }, 'slow');
    return false;
  });


  /* ================================================== */
  /* GOOGLE MAP
  /* ================================================== */

  // you want to enable the pointer events only on click;
  $('#map_canvas').addClass('scroll-off');
  $('.map').on('click', function () {
    $('#map_canvas').removeClass('scroll-off');
  });

  // you want to disable pointer events when the mouse leave the canvas area;
  $("#map_canvas").mouseleave(function () {
      $('#map_canvas').addClass('scroll-off');
  });


  /* ================================================== */
  /* HOVER EFFECT BY CATEGORIES
  /* ================================================== */  

  $('[data-category]').on('mouseover', function(){
    var catClass = '.' + $(this).attr('data-category');
    $(catClass).addClass('active');
  });

  $('[data-category]').on('mouseleave', function(){
    var catClass = '.' + $(this).attr('data-category');
    $(catClass).removeClass('active');
  });

});


/* ================================================== */
/* CALL FUNCTIONS
/* ================================================== */

$(document).ready(function(){

  loader();

});

$(document).on('load', function(){

  loader();

});

$(window).on('scroll resize orientationchange', function(){
	
  fixedNav();
  
});
